/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdBadgeProps } from './type';

export const badgeDefaultProps: TdBadgeProps = {
  count: 0,
  dot: false,
  maxCount: 99,
  shape: 'circle',
  showZero: false,
  size: 'medium',
};
